module.exports = __webpack_public_path__ + "static/media/ipvNavLogo.0b65b81f.svg";